module.exports = __webpack_public_path__ + "img/flag.662c8cdb.png";